import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { DialogModalWithChild } from '../../../modals/DialogModalWithChild';
import { setAsyncRouteLeaveHook } from '../utils';
import { saveThirdpartyApps, setChangedManageApps as setChangedManageAppsAction } from '../../../../actions/thirdparty';
import InputTextField from 'components/common/InputTextField';
import { SANITIZATION_TYPES } from '../../../common/sanitizationTypes';

class ThirdpartyLeaveModal extends Component {
    state = {
        comment: ''
    };

    componentWillMount() {
        setAsyncRouteLeaveHook(this.props.router, this.props.route, this.routerWillLeave);
    }

    saveData = () => {
        const { chainId, hotelId, saveApps, selectedLevel } = this.props;
        return saveApps(chainId, hotelId, selectedLevel, {}, this.state.comment);
    };

    routerWillLeave = () => {
        const { changedManageApps, setChangedManageApps, canShowModal = true } = this.props;
        return new Promise(resolve => {
            const openModal = true;
            if (!changedManageApps) {
                resolve({ finalResult: true });
            } else if (!canShowModal) {
                setChangedManageApps(false);
                resolve({ finalResult: true });
            } else {
                this.dialogRef.ask(
                    () => {
                        return this.saveData()
                            .then(result => {
                                resolve({ finalResult: result });
                            })
                            .catch(() => {
                                resolve({ finalResult: false });
                            });
                    },
                    () => {
                        setChangedManageApps(false);
                        resolve({ finalResult: true });
                    },
                    openModal
                );
            }
        });
    };

    render() {
        return (
            <DialogModalWithChild
                ref={node => (this.dialogRef = node)}
                secondaryButtonTitle="Discard"
                primaryButtonDisabled={!this.state.comment}
                onOpen={() => {
                    this.setState({
                        comment: ''
                    });
                }}
                title="Save 3rd Party Apps Changes"
            >
                <InputTextField
                    sparkInputProps={{ label: 'Change Comments*' }}
                    name="manage-apps-name"
                    value={this.state.comment}
                    sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                    replaceInValue={val => val.replace('<', '&lt;').replace('>', '&gt;')}
                    onChange={value => {
                        this.setState({ comment: value });
                    }}
                />
            </DialogModalWithChild>
        );
    }
}

ThirdpartyLeaveModal.propTypes = {
    saveApps: PropTypes.func.isRequired,
    chainId: PropTypes.string.isRequired,
    hotelId: PropTypes.string.isRequired,
    selectedLevel: PropTypes.string.isRequired,
    changedManageApps: PropTypes.bool.isRequired,
    canShowModal: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        selectedLevel: state.app.selected.level,
        changedManageApps: get(state, 'app.data.thirdparty.changedManageApps', false)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        saveApps: (chainId, hotelId, selectedLevel, savedData, comment) =>
            dispatch(saveThirdpartyApps(chainId, hotelId, selectedLevel, savedData, comment)),
        setChangedManageApps: value => dispatch(setChangedManageAppsAction(value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThirdpartyLeaveModal);



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/ThirdpartyLeaveModal.js